module.exports = __webpack_public_path__ + "static/media/luminosity.0f189e06.gif";